import Nav from './nav';
const Homedetails=()=>{
return(
    <div className="home_container">
        <Nav/>
    </div>
);
};
export default Homedetails;